export default __webpack_public_path__ + "static/media/9.1a1c37e0.jpg";